export const CUCA_ADMIN = 'cuca_admin';
export const DOWNLOADS = 'downloads';
export const EMAIL = 'email';
export const EMPLOYEES = 'employees';
export const RESERVATIONS = 'reservations';
export const SGW_ADMIN = 'sgw_admin';
export const PORTAL_OPTIONS = 'portal_options';
